(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["main-nav"] && !Shopify.designMode) return;
  try {
    (function () {
    var nav         = document.getElementById('cr-main-nav');
    var list        = document.getElementById('cr-main-nav-list');
    var overflowBtn = document.getElementById('cr-nav-overflow-btn');
    if (!nav || !list || !overflowBtn) return;

    var HYSTERESIS = 40;
    var overflowing = false;

    function checkOverflow() {
      if (!overflowing && list.scrollWidth > list.clientWidth + HYSTERESIS) {
        overflowing = true;
        overflowBtn.hidden = false;
      } else if (overflowing && list.scrollWidth <= list.clientWidth - HYSTERESIS) {
        overflowing = false;
        overflowBtn.hidden = true;
      }
    }

    window.addEventListener('resize', checkOverflow);
    checkOverflow();

    /* Mega menu: alterna painel L3 ao hover/focus na sidebar */
    nav.querySelectorAll('.cr-main-nav__mega').forEach(function (mega) {
      var items = mega.querySelectorAll('.cr-main-nav__mega-item--has-children[data-mega-panel]');
      var panels = mega.querySelectorAll('.cr-main-nav__mega-subpanel');
      if (!items.length || !panels.length) return;

      var panelMap = {};
      panels.forEach(function (panel) {
        panelMap[panel.id] = panel;
      });

      function showPanel(panelId, activeItem) {
        panels.forEach(function (panel) {
          if (panel.id === panelId) {
            panel.hidden = false;
          } else {
            panel.hidden = true;
          }
        });
        items.forEach(function (item) {
          item.classList.toggle('is-active', item === activeItem);
        });
      }

      function showDefaultPanel() {
        var firstItem = items[0];
        if (!firstItem) return;
        showPanel(firstItem.getAttribute('data-mega-panel'), firstItem);
      }

      items.forEach(function (item) {
        var panelId = item.getAttribute('data-mega-panel');
        if (!panelId || !panelMap[panelId]) return;

        item.addEventListener('mouseenter', function () {
          showPanel(panelId, item);
        });

        item.addEventListener('focusin', function () {
          showPanel(panelId, item);
        });
      });

      mega.addEventListener('mouseleave', showDefaultPanel);
      showDefaultPanel();
    });

    /* aria-expanded nos itens top-level com dropdown */
    nav.querySelectorAll('.cr-main-nav__item--has-panel').forEach(function (item) {
      var link = item.querySelector(':scope > .cr-main-nav__link');
      if (!link) return;

      item.addEventListener('mouseenter', function () {
        link.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('mouseleave', function () {
        link.setAttribute('aria-expanded', 'false');
      });
      item.addEventListener('focusin', function () {
        link.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) {
          link.setAttribute('aria-expanded', 'false');
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["top-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    var inner = document.getElementById('cr-topbar-inner');
    if (!inner) return;
    var items = inner.querySelectorAll('.cr-topbar__item');
    if (items.length < 2) return;

    var isMobile = function () { return window.innerWidth < 768; };
    var current = 0;

    function rotate() {
      if (!isMobile()) return;
      items[current].classList.remove('cr-topbar__item--active');
      current = (current + 1) % items.length;
      items[current].classList.add('cr-topbar__item--active');
    }

    setInterval(rotate, 7000);
  })();
  } catch(e) { console.error(e); }
})();

})();
